module.exports = __webpack_public_path__ + "assets/img/mo-poster-layer-14-7a7851a6.png";